import React from 'react'
import CtaFooter from '../ctaFooter/ctaFooter'
import AboutTheCompany from './aboutTheCompany/aboutTheCompany'
import AboutCompanyOverview from './aboutCompanyOverview/aboutCompanyOverview'
import AboutCompanyDetails from './aboutCompanyDetails/aboutCompanyDetails'
import NumbersCard from './numbersCard/numbersCard'

function About() {
    return (
        <>

            <AboutCompanyDetails />

            <NumbersCard />

            <AboutCompanyOverview />

            <AboutTheCompany />

            <CtaFooter />
        </>
    )
}

export default About